
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/ask-the-experts/[slug]",
      function () {
        return require("private-next-pages/guides/ask-the-experts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/ask-the-experts/[slug]"])
      });
    }
  